 
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar.component'; 

@NgModule({
    imports: [ CommonModule,  RouterModule], 
    declarations: [ NavbarComponent ],
    exports: [ NavbarComponent ] 
})
 
export class NavbarModule {}
